export class EventView {
	constructor() {
		this.$popupModal = $("#js-popup-modal");
	}

	showEventOnPopup() {
		this.$popupModal.find(".modal-body").html($("#js-places"));
		this.$popupModal.find(".places").show();
		this.$popupModal.find(".places__top").show();

		$(".places__middle").append($(".places__prices"));

		this.$popupModal.addClass("modal_mobile-event");

		this.$popupModal.modal();
	}
}
